import {
    getFirestore,
    collection,
    doc,
    query,
    where,
    orderBy,
    startAfter,
    limit,
    getDoc,
    getDocs,
    updateDoc,
    addDoc,
    setDoc,
    deleteDoc,
    increment,
} from "firebase/firestore";

import { db } from "../apis/auth";
import { format } from "date-fns";
import { timeConvertUtility } from "../utilities/utility";

const dimScheduleCollection = "dim_sch";
const dimScheduleDoc = "curr_sch";

export async function getDimSchedule() {
    console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule()`);
    const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        const record = docSnap.data();
        return Promise.resolve(record);
    }
    return Promise.reject("Unable to get dim schedule");
}

export async function getDimScheduleByILMID(ilm_id) {
    console.log(`===> Querying dimScheduleCollection for ilm_id: ${ilm_id}`);
    let snap = null;
    let docSnap = null;
    try {
        if (ilm_id === "") {
            const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
            docSnap = await getDoc(docRef);
        } else if (ilm_id) {
            const colRef = doc(db(), dimScheduleCollection, ilm_id);
            snap = await getDoc(colRef);
        }

        if (snap && snap.exists()) {
            return Promise.resolve(snap.data());
        } else if (docSnap && docSnap.exists()) {
            return Promise.resolve(docSnap.data());
        } else {
            return Promise.resolve(null);
        }
    } catch (error) {
        return Promise.resolve(null);
    }
}

export async function fetchDimSchedule(ilm_id) {
    console.log(`===> Querying dimScheduleCollection for ilm_id: ${ilm_id}`);
    let snap = null;
    let docSnap = null;

    try {
        if (ilm_id === "") {
            // If ilm_id is empty, fall back to querying dimScheduleDoc
            const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
            docSnap = await getDoc(docRef);
        } else if (ilm_id) {
            // Try to query using ilm_id first
            const colRef = doc(db(), dimScheduleCollection, ilm_id);
            snap = await getDoc(colRef);

            // If ilm_id doesn't exist, fall back to querying dimScheduleDoc
            if (!snap.exists()) {
                console.log(`ilm_id: ${ilm_id} not found, falling back to dimScheduleDoc.`);
                const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
                docSnap = await getDoc(docRef);
            }
        }

        // Return data if found from either snap or docSnap
        if (snap && snap.exists()) {
            return Promise.resolve(snap.data());
        } else if (docSnap && docSnap.exists()) {
            return Promise.resolve(docSnap.data());
        } else {
            return Promise.reject("No matching documents found.");
        }
    } catch (error) {
        console.error("Error getting documents: ", error);
        alert(`An error occurred: ${error.message}`);
        return Promise.reject("Unable to get dim schedule.");
    }
}

// export const getScheduleInfo = async (uid = "") => {
//     let scheduleInfo = null;
//     let docId = null;

//     try {
//         let q = query(
//             collection(db(), "schedules"),
//             where("name", "==", uid)
//         );
//         const querySnapshot = await getDocs(q);

//         if (!querySnapshot.empty) {
//             for (const doc of querySnapshot.docs) {
//                 docId = doc.id;
//                 scheduleInfo = doc.data();

//                 if (scheduleInfo.enabled) {
//                     return { docId, scheduleInfo };
//                 }
//             }
//         } else {
//             console.log("No schedule found for UID, querying default...");
//             q = query(
//                 collection(db(), "schedules"),
//                 where("name", "==", "default")
//             );
//             const defaultSnapshot = await getDocs(q);

//             if (!defaultSnapshot.empty) {
//                 for (const doc of defaultSnapshot.docs) {
//                     docId = doc.id;
//                     scheduleInfo = doc.data();
//                     return { docId, scheduleInfo };
//                 }
//             }
//         }


//         if (!scheduleInfo) {
//             return Promise.reject("Unable to get schedule info");
//         }

//     } catch (error) {
//         console.error("Error fetching schedule info:", error);
//         return Promise.reject("Error fetching schedule info");
//     }
// };

export const getScheduleInfo = async (uid = "") => {
    let scheduleInfo = null;
    let docId = null;

    try {
        let q = query(
            collection(db(), "schedules"),
            where("name", "==", uid)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            for (const doc of querySnapshot.docs) {
                docId = doc.id;
                scheduleInfo = doc.data();

                if (scheduleInfo.enabled) {
                     if (!scheduleInfo.slot_times || !Array.isArray(scheduleInfo.slot_times)) {
                        scheduleInfo.slot_times = [{
                              on_time: scheduleInfo.on_time || { hrs: 0, mins: 0 },
                            off_time: scheduleInfo.off_time || { hrs: 0, mins: 0 }
                        }];
                    }
                    return { docId, scheduleInfo };
                }
            }
        } else {
            console.log("No schedule found for UID, querying default...");
            q = query(
                collection(db(), "schedules"),
                where("name", "==", "default")
            );
            const defaultSnapshot = await getDocs(q);

            if (!defaultSnapshot.empty) {
                for (const doc of defaultSnapshot.docs) {
                    docId = doc.id;
                    scheduleInfo = doc.data();
                    
                    if (!scheduleInfo.slot_times || !Array.isArray(scheduleInfo.slot_times)) {
                        scheduleInfo.slot_times = [{
                             on_time: scheduleInfo.on_time || { hrs: 0, mins: 0 },
                            off_time: scheduleInfo.off_time || { hrs: 0, mins: 0 }
                        }];
                    }
                    return { docId, scheduleInfo };
                }
            }
        }

        if (!scheduleInfo) {
            return Promise.reject("Unable to get schedule info");
        }

    } catch (error) {
        console.error("Error fetching schedule info:", error);
        return Promise.reject("Error fetching schedule info");
    }
};


export async function getTicketFlag() {
    console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule()`);
    const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        const record = docSnap.data();
        return Promise.resolve(record);

    }
    return Promise.reject("Unable to get dim schedule");
}

export async function updateDimSchedule(dimScheduleData) {
    console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule() data = ${JSON.stringify(dimScheduleData)}`);
    const docRef = doc(db(), dimScheduleCollection, dimScheduleDoc);
    await setDoc(docRef, dimScheduleData);
    // if (docSnap.exists()) {
    return Promise.resolve();
    // }
    // return Promise.reject("Unable to update dim schedule"); 
}
export async function updateDimScheduleFromPopup(dimScheduleData) {
    console.log(`===> ${dimScheduleCollection}-Query : getDimSchedule() data = ${JSON.stringify(dimScheduleData)}`);
    const docRef = doc(db(), dimScheduleCollection, dimScheduleData.name);
    await setDoc(docRef, dimScheduleData);
    // if (docSnap.exists()) {
    return Promise.resolve();
    // }
    // return Promise.reject("Unable to update dim schedule"); 
}

export async function updateIndividualDimScheduleFlag(dimScheduleData) {


    const docRef = doc(db(), dimScheduleCollection, dimScheduleData.name);
    const docSnapshot = await getDoc(docRef);
    if (docSnapshot.exists()) {
        await updateDoc(docRef, {
            enabled: dimScheduleData.enabled,
            ver: increment(1)
        }).then(async () => {
            const q = query(
                collection(db(), "dim_sch_history"),
                where("name", "==", dimScheduleData.name),
                orderBy("ch_dt", "desc"),
            );
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                
            } else {
                const doc = querySnapshot.docs[0];
                const docData = doc.data();
                docData.enabled = dimScheduleData.enabled;
                docData.ver = docData.ver + 1;
                docData.ch_dt = new Date();
                const docRef = collection(db(), "dim_sch_history");
                await addDoc(docRef, docData);
            }
        });
    }
    return Promise.resolve(); // Return a resolved promise after update or creation
}
export async function updateFlag(dimScheduleData, historyData) {
     const docRef = doc(db(), "schedules", dimScheduleData.name);
    const docSnapshot = await getDoc(docRef);
    historyData.enabled = dimScheduleData.enabled;
    historyData.version = historyData.version + 1;
    historyData.ch_dt = new Date();
    historyData.user = dimScheduleData.user; 
 
    if (docSnapshot.exists()) {
        await updateDoc(docRef, {
            enabled: dimScheduleData.enabled,
            version: historyData.version,
            // user:dimScheduleData.user,
            ch_dt: new Date()
        }).then(() => {
            addDoc(collection(db(), "schedule_history"), {
                ...historyData,
            })
        })
    } else {
         console.log(`Document with name ${dimScheduleData.name} does not exist.`);
    }

    return Promise.resolve(); // Return a resolved promise after the update
}

export const getSchedule = async (uid = "") => {

    let scheduleInfo = "";
    let docId = null;

    try {
        let q = query(
            collection(db(), "schedules"),
            where("name", "==", uid)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
                docId = doc.id;
                scheduleInfo = doc.data();
            });
        } else {
            console.log("No schedule found for UID, querying default...");
            q = query(
                collection(db(), "schedules"),
                where("name", "==", "default")
            );
            const defaultSnapshot = await getDocs(q);
            if (!defaultSnapshot.empty) {
                defaultSnapshot.forEach((doc) => {
                    docId = doc.id;
                    scheduleInfo = doc.data();
                });
            }
        }

        if (scheduleInfo) {
            return Promise.resolve({ docId, scheduleInfo });
        } else {
            return Promise.reject("Unable to get schedule info");
        }

    } catch (error) {
        console.error("Error fetching schedule info:", error);
        return Promise.reject("Error fetching schedule info");
    }
};

// export const getScheduleHistoryAPICall = (uid = "") => {
//     return new Promise(async (resolve, reject) => {
//         try {
//             let historyList = [];

//             const q = query(
//                 collection(db(), "schedule_history"),
//                 where("name", "==", uid),
//                 orderBy("ch_dt", "desc")
//             );
//             const querySnapshot = await getDocs(q);

//             querySnapshot.forEach((doc) => {
//                 const record = doc.data();
//                 historyList.push(record);
//             });

//             const formattedHistory = historyList.map((historyItem) => {
//                 const { user: lastModifiedBy, ch_dt: { seconds } = {} } = historyItem || {};
//                 const { onTime, offTime } = timeConvertUtility(historyItem);
//                 const lastModifiedDate = seconds ? format(new Date(seconds * 1000), "dd/MM/yyyy") : "N/A";
//                 const name = historyItem.name;
//                 return {
//                     onTime,
//                     offTime,
//                     lastModifiedBy,
//                     lastModifiedDate,
//                     name,
//                 };
//             });
//             resolve(formattedHistory);

//         } catch (error) {
//             console.error("Error fetching schedule history:", error);
//             reject("Error fetching schedule history");
//         }
//     });
// };

export const getScheduleHistoryAPICall = (uid = "") => {
    return new Promise(async (resolve, reject) => {
        try {
            let historyList = [];

            const q = query(
                collection(db(), "schedule_history"),
                where("name", "==", uid),
                orderBy("ch_dt", "desc")
            );

            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                querySnapshot.forEach((doc) => {
                    const record = doc.data();
                    historyList.push(record);
                });
            } 
            // else {
            //     const defaultQuery = query(
            //         collection(db(), "schedule_history"),
            //         where("name", "==", "default"),
            //         orderBy("ch_dt", "desc")
            //     );

            //     const defaultSnapshot = await getDocs(defaultQuery);

            //     if (!defaultSnapshot.empty) {
            //         defaultSnapshot.forEach((doc) => {
            //             const record = doc.data();
            //             historyList.push(record);
            //         });
            //     } else {
            //         return resolve([]);
            //     }
            // }
            
            const formattedHistory = historyList.map((historyItem) => {
                const { user: lastModifiedBy, ch_dt: { seconds } = {} } = historyItem || {};
                const { onTime, offTime } = timeConvertUtility(historyItem);
                const lastModifiedDate = seconds ? format(new Date(seconds * 1000), "dd/MM/yyyy") : "N/A";
                const name = historyItem.name;
                const enabled = historyItem.enabled;
                const scList = schedlueData(historyItem.slot_times);

                return {
                    onTime,
                    offTime,
                    scList,
                    lastModifiedBy,
                    lastModifiedDate,
                    name,
                    enabled
                };
            });

            resolve(formattedHistory);

        } catch (error) {
            alert(error)
            console.error("Error fetching schedule history:", error);
            reject("Unable to process your request");
        }
    });
};

const transformData = (data) => {
    const formatTime = (time) => {
        let { hrs, mins } = time;
        let period = "AM";
        if (hrs >= 12) {
            period = "PM";
            if (hrs > 12) {
                hrs -= 12;
            }
        } else if (hrs === 0) {
            hrs = 12;
        }
        return `${hrs}.${String(mins).padStart(2, '0')} ${period}`;
    };
    var result = data.map((item, index) => {
        const formattedItem = `off : ${formatTime(item.off_time)}, dp : ${item.dp}, on : ${formatTime(item.on_time)}`;
        return index === data.length - 1 ? formattedItem : formattedItem + ' - ';
    });

    return result;
};
const schedlueData = (data) => {
    const formatTime = (time) => {
        let { hrs, mins } = time;
        let period = "AM";
        if (hrs >= 12) {
            period = "PM";
            if (hrs > 12) {
                hrs -= 12;
            }
        } else if (hrs === 0) {
            hrs = 12;
        }
        return `${hrs}.${String(mins).padStart(2, '0')} ${period}`;
    };
    var result = data?.map((item, index) => {
        const formattedItem = ` on : ${formatTime(item.on_time)} - off : ${formatTime(item.off_time)}`;
        return index === data.length - 1 ? formattedItem : formattedItem + ' , ';
    });

    return result;
};


export const getDimScheduleHistoryAPICall = (uid = "") => {
    return new Promise(async (resolve, reject) => {
        try {
            let historyList = [];

            const q = query(
                collection(db(), "dim_sch_history"),
                where("name", "==", uid),
                orderBy("ch_dt", "desc")
            );
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                querySnapshot.forEach((doc) => {
                    const record = doc.data();
                    historyList.push(record);
                });
            } else {

                let defaultQuery = doc(db(), "dim_sch_history", dimScheduleDoc);
                const defaultSnapshot = await getDocs(defaultQuery);

                if (!defaultSnapshot.empty) {

                    defaultSnapshot.forEach((doc) => {
                        const record = doc.data();
                        historyList.push(record);
                    });
                } else {
                    return resolve(historyList);
                }
            }
            const formattedHistory = historyList.map((schedule) => {
                const { user: lastModifiedBy, ch_dt: { seconds } = {} } = schedule || {};
                const scList = transformData(schedule.sch_list);
                const lastModifiedDate = seconds ? format(new Date(seconds * 1000), "dd/MM/yyyy, hh:mm a") : "N/A";
                const name = schedule.name;
                const dp = schedule.dp || 0;
                const enabledStatus = schedule.enabled ? "Enabled" : "Disabled";

                return {
                    name,
                    scList,
                    lastModifiedBy,
                    lastModifiedDate,
                    dp,
                    enabledStatus
                };
            });
            resolve(formattedHistory);

        } catch (error) {
            return resolve([]);
        }
    });
};

